import { Component } from "react";
import { Translation } from "react-i18next";
import googleBadge from "./../../images/greyscale-short.svg";

export default class GoogleTranslateAttributionBadge extends Component {
  render() {
    return (
      <Translation>
        {t => (
          <a href="//translate.google.com" target="_blank" rel="noopener noreferrer">
            <img src={googleBadge} alt={t("Common.googleTranslateBadge.label")} />
          </a>
        )}
      </Translation>
    );
  }
}
